<script>
  import { _ } from "../stores/index";
  import { AppsRepository } from "../repositories/index";
  import {
    Flex,
    FlexItem,
    Button,
    Form,
    Submit,
    TextField,
    Modal,
    Select,
    SelectItem,
  } from "@gl/design-system";
  import { createEventDispatcher, onMount } from "svelte";
  import { ModalType } from "../types/modal";
  const dispatch = createEventDispatcher();

  export let active;
  export let modalType;
  export let data;

  let loading = {};

  let form = { policyDefinition: "internal", type: "gl-access-manager" };

  const allowedTypes = [
    "gl-access-manager",
    "gl-compositor",
    "gl-graphics-manager",
    "gl-channel-manager",
    "gl-content-manager",
    "gl-compositor-manager",
    "gl-node-manager",
    "gl-cut-manager",
  ];

  const isValidIdAndName = (value) => {
    const result = /^[a-zA-Z0-9 ()#\-_+=.,;:<>öäü]{3,45}$/.test(value);
    return [
      result,
      $_("^(?!^s+$)[A-Za-zöäüßs'-]*[A-Za-zöäüß][A-Za-zöäüßs'-]*$"),
    ];
  };

  const onSubmit = async () => {
    const requestBody = {
      name: form.name,
      type: form.type,
      policyDefinition: form.policyDefinition,
    };
    try {
      loading.submit = true;
      modalType === ModalType.Put
        ? await AppsRepository.editApplication(data.id, requestBody)
        : await AppsRepository.addApplication(form.id, requestBody);
    } finally {
      loading.submit = false;
      dispatch("success");
    }
  };

  onMount(() => {
    if (data) {
      form.name = data.name;
      form.id = data.id;
      form.type = data.type;
      form.policyDefinition = data.policyDefinition;
    }
  });
</script>

<Modal bind:active boxed on:close>
  <div class="gl-title mb-4">
    {modalType === ModalType.Put ? $_("apps.edit_app") : $_("apps.add_app")}
  </div>
  <Form validationMode="eager">
    <TextField
      bind:value={form.id}
      id="app-id"
      label="ID"
      disabled={modalType === ModalType.Put}
      required={$_("validations.required")}
      validate={(value) => isValidIdAndName(value)}
      maxLength={45}
      config={{ characterCount: $_("character.count") }}
    />

    <TextField
      bind:value={form.name}
      id="app-name"
      label={$_("common.name")}
      required={$_("validations.required")}
      validate={(value) => isValidIdAndName(value)}
      maxLength={45}
      config={{ characterCount: $_("character.count") }}
    />

    <Select label={$_("common.type")} bind:value={form.type} id="app-type">
      {#each allowedTypes as type}
        <SelectItem label={type} value={type} />
      {/each}
    </Select>

    <Select
      label={$_("apps.policy.definition")}
      bind:value={form.policyDefinition}
      id="policyDefinition"
    >
      {#each ["external", "internal"] as definition}
        <SelectItem label={definition} value={definition} />
      {/each}
    </Select>

    <Flex>
      <FlexItem>
        <Submit
          loading={loading.submit}
          on:submit={onSubmit}
          label={$_("buttons.save")}
        />
      </FlexItem>
      <FlexItem class="ml-4">
        <Button outlined on:click={() => dispatch("close")}>
          {$_("buttons.cancel")}
        </Button>
      </FlexItem>
    </Flex>
  </Form>
</Modal>
